import React from "react";
import { LANDING_NAV_ITEMS } from "./landingNav";

export function LandingDock({ visible = false }) {
  return (
    <nav
      className={`landing-dock ${visible ? "is-visible" : ""}`}
      aria-label="Quick navigation"
      aria-hidden={!visible}
    >
      {LANDING_NAV_ITEMS.map((item) => (
        <a key={item.id} href={`#${item.id}`} className="landing-dock__item">
          {item.label}
        </a>
      ))}
    </nav>
  );
}
